import modifyContent from './modifyContent';
import deliveryImgInfoOnWriting from './deliveryImgInfoOnWriting';

const store = { modifyContent, deliveryImgInfoOnWriting };
export default store;
